import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';

@Component({
    selector: 'data-field-edit-custom-text',
    template: `
        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ dataField.Name }}</mat-label>
                <input matInput [(ngModel)]="dataField.Value" [required]="isSetRequired()" autocomplete="false" />
                <mat-error>{{ 'common_error.mandatory' | fiAppText }}</mat-error>
            </mat-form-field>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'data-field-edit-custom-text' },
    standalone: false,
})
export class DataFieldEditCustomTextComponent extends DataFieldEditBase {}
